import { nameSchema } from 'schema/company/CompanySchema'
import {
  authorityCodeSchema,
  emailSchema,
  passwordSchema,
  userCodeSchema
} from 'schema/validator'
import z from 'zod'

export type SignupUserSchemaType = z.infer<typeof SignupUserSchema>
export const SignupUserSchema = z.object({
  email: emailSchema,
  password: passwordSchema,
  name: nameSchema,
  authorityCode: authorityCodeSchema,
  userCode: userCodeSchema
})
